import React, { FunctionComponent } from 'react';

import { ExtendedFile } from '@savgroup-front-common/types';

import { AddAndRemove } from '../../../AddAndRemove';
import { FieldMessages } from '../../common/helpers/getFinalFieldState.types';

import AttachmentItem from './components/AttachmentItem';

interface AttachmentsListProps {
  files: ExtendedFile[];
  onRemove?: (attachment: ExtendedFile, index: number) => void;
  name: string;
  isLiveUpload?: boolean;
  errors: FieldMessages;
}

const AttachmentsList: FunctionComponent<
  React.PropsWithChildren<AttachmentsListProps>
> = ({ files = [], onRemove, name, isLiveUpload = true, errors }) => {
  return files.map((file, index) => (
    <AddAndRemove
      key={
        file.internalId || file.id || file.name || String(`${name}.${index}`)
      }
    >
      <AttachmentItem
        index={index}
        file={file}
        onRemove={onRemove}
        name={`${name}.${index}`}
        isLiveUpload={isLiveUpload}
        errors={errors}
      />
    </AddAndRemove>
  ));
};

export default AttachmentsList;
